import React, { useState, useEffect } from 'react';
import {
  getAllSchedules,
  getAllTeachers,
  addSchedule,
  updateSchedule,
  deleteSchedule
} from '../../services/api';

// Hàm chuyển ngày (Date string) thành chuỗi T2, T3, ... CN
const getScheduleDayLabel = (dateStr) => {
  const day = new Date(dateStr).getDay();
  switch (day) {
    case 0: return 'CN';   // Chủ nhật
    case 1: return 'T2';   // Thứ 2
    case 2: return 'T3';   // Thứ 3
    case 3: return 'T4';   // Thứ 4
    case 4: return 'T5';   // Thứ 5
    case 5: return 'T6';   // Thứ 6
    case 6: return 'T7';   // Thứ 7
    default: return '';
  }
};

const AdminSchedule = () => {
  const [teachers, setTeachers] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingSchedule, setEditingSchedule] = useState(null);
  const [form, setForm] = useState({
    major: '',
    teacherId: '',
    grade: '',
    startTime: '',
    endTime: '',
    room: '',
    date: '',
    scheduleDay: '',
  });
  const [searchTerm, setSearchTerm] = useState('');

  // Phân trang
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [tsRes, schRes] = await Promise.all([
        getAllTeachers(),
        getAllSchedules()
      ]);
      setTeachers(tsRes.data);
      setSchedules(schRes.data);
    } catch (err) {
      console.error('Lấy dữ liệu thất bại:', err);
    }
  };

  const schedulesWithTeacherInfo = schedules.map(sch => {
    const teacher = teachers.find(t => t.id === sch.teacher_id);
    return {
      ...sch,
      teacher_full_name: teacher?.full_name || 'Không rõ',
      teacher_degree: teacher?.degree || '',
      teacher_major: teacher?.major || '',
      teacher_phone: teacher?.phone_number || '',
      teacher_image_url: teacher?.image_url || '',
    };
  });

  // Phân trang tính toán
  const filteredSchedules = schedulesWithTeacherInfo.filter(sch => {
    const keyword = searchTerm.toLowerCase();
    return (
      sch.teacher_full_name.toLowerCase().includes(keyword) ||
      sch.major.toLowerCase().includes(keyword) ||
      sch.teacher_major.toLowerCase().includes(keyword)
    );
  });

  const totalPages = Math.ceil(filteredSchedules.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSchedules = filteredSchedules.slice(indexOfFirstItem, indexOfLastItem);


  // Chuyển trang
  const paginate = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  // Xử lý submit form thêm/sửa
  const handleSubmit = async () => {
    if (!form.teacherId) {
      alert('Vui lòng chọn giáo viên!');
      return;
    }
    if (!form.date) {
      alert('Vui lòng chọn ngày!');
      return;
    }
    if (!form.startTime || !form.endTime) {
      alert('Vui lòng nhập thời gian bắt đầu và kết thúc!');
      return;
    }
    if (!form.scheduleDay) {
      alert('Vui lòng chọn ngày học!');
      return;
    }

    const teacher = teachers.find(t => t.id === parseInt(form.teacherId, 10));
    const subject = form.major || teacher?.major || '';

    const payload = {
      teacher_id: parseInt(form.teacherId, 10), // ✅ chuyển string sang số nếu cần
      teacher_name: teacher?.full_name || '',
      subject,
      room: form.room,
      grade: form.grade,
      schedule_date: form.date,
      start_time: form.startTime,
      end_time: form.endTime,
      days: [form.scheduleDay],
    };

    console.log(payload)

    try {
      if (editingSchedule) {
        await updateSchedule(editingSchedule.id, payload);
      } else {
        await addSchedule(payload);
      }
      await fetchData();
      closeModal();
    } catch (err) {
      console.error('Lưu thông tin thất bại:', err);
      if (err.response) {
        alert('Lỗi: ' + err.response.data.message);
      } else {
        alert('Lỗi: ' + err.message);
      }
    }
  };

  const handleEdit = (schedule) => {
    const [start, end] = schedule.time_range.split(' - ');
    const daysArray = schedule.schedule_day.split('/');
    const firstDay = daysArray[0];

    setForm({
      major: schedule.subject || '',
      teacherId: schedule.teacher_id.toString(),
      grade: schedule.grade,
      startTime: start,
      endTime: end,
      room: schedule.room,
      date: schedule.schedule_date.slice(0, 10),
      scheduleDay: firstDay || getScheduleDayLabel(schedule.schedule_date),
    });
    setEditingSchedule(schedule);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Bạn có chắc muốn xóa lịch này không?')) {
      try {
        await deleteSchedule(id);
        await fetchData();
      } catch (err) {
        console.error('Xóa thất bại:', err);
        alert('Xóa thất bại');
      }
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingSchedule(null);
    setForm({
      major: '',
      teacherId: '',
      grade: '',
      startTime: '',
      endTime: '',
      room: '',
      date: '',
      scheduleDay: '',
    });
  };

  const getStatus = (dateStr, timeRange) => {
    const now = new Date();
    const [start, end] = timeRange.split(' - ');
    const dStart = new Date(`${dateStr}T${start}`);
    const dEnd = new Date(`${dateStr}T${end}`);
    if (now < dStart) return 'Sắp diễn ra';
    if (now > dEnd) return 'Đã kết thúc';
    return 'Đang diễn ra';
  };

  const getStatusColor = status => {
    switch (status) {
      case 'Đang diễn ra': return 'text-green-600 bg-green-100';
      case 'Sắp diễn ra': return 'text-blue-600 bg-blue-100';
      case 'Đã kết thúc': return 'text-gray-600 bg-gray-100';
      default: return 'text-gray-600 bg-gray-100';
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Quản Lý Lịch Học</h1>
      <div className="mb-4">
        <input
          type="text"
          placeholder="🔍 Tìm theo giáo viên, môn học hoặc chuyên ngành..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1); // Reset về trang đầu khi tìm
          }}
          className="w-full max-w-md border px-4 py-2 rounded shadow-sm"
        />
      </div>

      <button
        onClick={() => setShowModal(true)}
        className="mb-6 bg-blue-600 text-white px-4 py-2 rounded"
      >
        + Thêm Lịch Học
      </button>

      <div className="space-y-4">
        {currentSchedules.map(sch => {
          const status = getStatus(sch.schedule_date, sch.time_range);
          return (
            <div key={sch.id} className="p-4 bg-white rounded shadow flex justify-between items-center">
              <div className="flex gap-4 items-center">
                {sch.teacher_image_url && (
                  <img
                    src={sch.teacher_image_url}
                    alt={sch.teacher_full_name}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                )}
                <div>
                  <h4 className="text-lg font-semibold">{sch.major}</h4>
                  <p><strong>Giáo viên:</strong> {sch.teacher_full_name} ({sch.teacher_degree})</p>
                  <p><strong>Chuyên ngành:</strong> {sch.teacher_major}</p>
                  <p><strong>Điện thoại:</strong> {sch.teacher_phone}</p>
                  <p><strong>Lớp:</strong> {sch.grade}</p>
                  <p>🕒 {sch.time_range} ngày {new Date(sch.schedule_date).toLocaleDateString()}</p>
                  <p>🏫 Phòng: {sch.room}</p>
                  <p><strong>Ngày học (Schedule day):</strong> {sch.schedule_day}</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <span className={`px-3 py-1 rounded-full text-sm ${getStatusColor(status)}`}>{status}</span>
                <button onClick={() => handleEdit(sch)} className="text-blue-600">✏️</button>
                <button onClick={() => handleDelete(sch.id)} className="text-red-600">🗑️</button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Phân trang */}
      <div className="flex justify-center mt-6 gap-2 items-center">
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 rounded border disabled:opacity-50"
        >
          Prev
        </button>

        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i + 1}
            onClick={() => paginate(i + 1)}
            className={`px-3 py-1 rounded border ${currentPage === i + 1 ? 'bg-blue-600 text-white' : 'bg-white text-black'}`}
          >
            {i + 1}
          </button>
        ))}

        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1 rounded border disabled:opacity-50"
        >
          Next
        </button>
      </div>

      {/* Modal thêm/sửa */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">{editingSchedule ? 'Chỉnh sửa Lịch Học' : 'Thêm Lịch Học'}</h2>
            <div className="space-y-3">
              <input
                value={form.major}
                onChange={e => setForm({ ...form, major: e.target.value })}
                placeholder="Môn học (có thể để trống để lấy theo chuyên ngành giáo viên)"
                className="w-full border px-3 py-2 rounded"
              />
              <select
                value={form.teacherId}
                onChange={e => setForm({ ...form, teacherId: e.target.value })}
                className="w-full border px-3 py-2 rounded"
              >
                <option value="">Chọn giáo viên</option>
                {teachers.map(t => (
                  <option key={t.id} value={t.id}>{t.full_name}</option>
                ))}
              </select>
              <input
                value={form.grade}
                onChange={e => setForm({ ...form, grade: e.target.value })}
                placeholder="Khối"
                className="w-full border px-3 py-2 rounded"
              />
              <div className="flex gap-2">
                <input
                  type="time"
                  value={form.startTime}
                  onChange={e => setForm({ ...form, startTime: e.target.value })}
                  className="flex-1 border px-3 py-2 rounded"
                  placeholder="Giờ bắt đầu"
                />
                <input
                  type="time"
                  value={form.endTime}
                  onChange={e => setForm({ ...form, endTime: e.target.value })}
                  className="flex-1 border px-3 py-2 rounded"
                  placeholder="Giờ kết thúc"
                />
              </div>
              <input
                value={form.room}
                onChange={e => setForm({ ...form, room: e.target.value })}
                placeholder="Phòng học"
                className="w-full border px-3 py-2 rounded"
              />
              <input
                type="date"
                value={form.date}
                onChange={e => setForm({ ...form, date: e.target.value })}
                className="w-full border px-3 py-2 rounded"
              />
              <select
                value={form.scheduleDay}
                onChange={e => setForm({ ...form, scheduleDay: e.target.value })}
                className="w-full border px-3 py-2 rounded"
              >
                <option value="">Chọn ngày học</option>
                <option value="T2">Thứ 2</option>
                <option value="T3">Thứ 3</option>
                <option value="T4">Thứ 4</option>
                <option value="T5">Thứ 5</option>
                <option value="T6">Thứ 6</option>
                <option value="T7">Thứ 7</option>
                <option value="CN">Chủ nhật</option>
              </select>
            </div>
            <div className="flex mt-6 gap-4">
              <button
                onClick={closeModal}
                className="flex-1 bg-gray-300 py-2 rounded"
              >
                Hủy
              </button>
              <button
                onClick={handleSubmit}
                disabled={!form.teacherId || !form.date || !form.startTime || !form.endTime || !form.scheduleDay}
                className="flex-1 bg-blue-600 text-white py-2 rounded disabled:opacity-50"
              >
                {editingSchedule ? 'Cập nhật' : 'Thêm Mới'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSchedule;
